import React, { useEffect } from 'react';
import { Checkbox, Form, Input} from 'antd';
import InputWithSearchModal from '../../components/InputWithSearchModal';
import UserFilter from '../UserFilter';
import UserSelector from '../UserSelector';
import Tooltip from '../../components/Tooltip';

export default function NoviePromokodi(props) {
    const { auth, object, form } = props;
    console.log(props)
    useEffect(() => {
        form.resetFields();
    }, []);
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item label="Промокод"
                    name="promokod"
                    rules={[{ required: true, message: 'Пожалуйста, укажите промокод!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Описание"
                    name="opisanie"
                    rules={[{ required: true, message: 'Пожалуйста, укажите описание!' }]}
                >
                    <Input />
                </Form.Item>
                {(props?.event?.ID>0) && <Form.Item
                    name="shablonniiPromokod"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Шаблонный промокод
                        <Tooltip title='Школы, организаторы, независимые преподаватели могут самостоятельно создавать промокоды по шаблону, который задается в шаблонном промокоде.' />
                    </Checkbox>
                </Form.Item>}
                <Form.Item
                    name="notActive"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Неактивный
                    </Checkbox>
                </Form.Item>
                <Form.Item
                    name={"promouter"}
                    label={"Промоутер"}
                    tooltip='Пользователь, который является владельцем этого промокода, получающий агентское вознаграждение по этому промокоду.'
                    rules={[{ required: false, message: 'Укажите промоутера!' }]}
                >
                    <InputWithSearchModal valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{ }}
                        searchForm={UserFilter}
                        selectForm={UserSelector} />
                </Form.Item>
            </Form>
        </>
    );
}
